import axios from "axios";
import { SERVER_URL } from "../../config";
import { appendTimestamp, MARRY_STATUS_MAP } from "../../common/shared";

const TAX_FILING_STATUS_SINGLE = "SINGLE";
const TAX_FILING_STATUS_MARRIED_JOINT = "MARRIED_FILING_JOINTLY";
const TAX_FILING_STATUS_MARRIED_SEPARATE = "MARRIED_FILING_SEPARATELY";
const TAX_FILING_STATUS_HEAD = "HEAD_OF_HOUSEHOLD";

const mapBEIncomeToFETaxGlidePath = (taxGlidePath) => {
  let taxGlidePathVO = { ...taxGlidePath };
  taxGlidePathVO.deductionInflation = taxGlidePath.deductionInflation / 100;
  taxGlidePathVO.isMarried = {
    key: taxGlidePathVO.isMarried,
    name: MARRY_STATUS_MAP[taxGlidePathVO.isMarried],
  };
  return taxGlidePathVO;
};

const mapFEIncomeToBETaxGlidePath = (taxGlidePathVO) => {
  let taxGlidePath = { ...taxGlidePathVO };
  taxGlidePath.deductionInflation = taxGlidePathVO.deductionInflation * 100;
  taxGlidePath.isMarried = taxGlidePathVO.isMarried.key;
  return taxGlidePath;
};

const mapFETaxPeriodToBE = (planId) => {
  return (tax) => {
    return {
      planId: planId,
      taxPeriodId: tax.id,
      taxPeriodType: tax.taxPeriodType,
      taxRate: tax.taxRate * 100,
      taxState: null,
      title: tax.name,
      date: {
        endDateType: "REGULAR_DATE",
        endMonth: null,
        endYear: tax.endYear,
        relativeEndDateNum: 0,
        relativeStartDateNum: 0,
        startDateType: "REGULAR_DATE",
        startMonth: null,
        startYear: tax.startYear,
      },
    };
  };
};

export const getClientTaxGlidePath = (advisorId, clientId) => {
  console.log("Advisor Clients - getClientTaxGlidePath");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/tax-glide-path`
    );

    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;
      resolve(mapBEIncomeToFETaxGlidePath(payload));
    });
  });
};

export const getClientTaxGlidePathIncomeSummary = (advisorId, clientId) => {
  console.log("Advisor Clients - getClientTaxGlidePathIncomeSummary");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/tax-glide-path/income-summary`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const updateClientTaxGlidePath = (advisorId, clientId, taxGlidePath) => {
  console.log("Advisor Clients - updateClientTaxGlidePath");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/tax-glide-path`
    );
    const payload = mapFEIncomeToBETaxGlidePath(taxGlidePath);

    axios.put(targetUrl, payload).then(() => {
      resolve({});
    });
  });
};

export const getClientMarginalTaxBracket = (advisorId, clientId) => {
  console.log("Advisor Clients - getClientMarginalTaxBracket");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/marginal-tax-bracket`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const updateClientMarginalTaxBracket = (
  advisorId,
  clientId,
  marginalTaxBracket
) => {
  console.log("Advisor Clients - updateClientMarginalTaxBracket");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/marginal-tax-bracket`
    );

    axios.put(targetUrl, marginalTaxBracket).then(() => {
      resolve({});
    });
  });
};

export const getPlanMarginalTaxBracket = (advisorId, clientId, planId) => {
  console.log("Plan Taxes - getPlanMarginalTaxBracket");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/plan/${planId}/marginal-tax-bracket`
    );

    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;
      resolve(payload);
    });
  });
};

export const updatePlanMarginalTaxBracket = (
  advisorId,
  clientId,
  planId,
  marginalTaxBracket
) => {
  console.log("Plan Taxes - updatePlanMarginalTaxBracket");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/plan/${planId}/marginal-tax-bracket`
    );

    axios.post(targetUrl, marginalTaxBracket).then(() => resolve({}));
  });
};

export const getPlanTaxDeduction = (advisorId, clientId, planId) => {
  console.log("Plan Taxes - getPlanTaxDeducation");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/plan/${planId}/tax-deduction`
    );

    axios.get(targetUrl).then((response) => {
      const payload = response.data.payload;
      console.log(payload);
      resolve(payload);
    });
  });
};

export const savePlanTaxDeduction = (
  advisorId,
  clientId,
  planId,
  taxDeductions
) => {
  console.log("Plan Taxes - savePlanTaxDeduction");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/plan/${planId}/tax-deduction`
    );

    axios.post(targetUrl, taxDeductions).then(() => resolve({}));
  });
};

export const updatePlanTaxPeriod = (
  advisorId,
  clientId,
  planId,
  taxPeriodList
) => {
  console.log("Plan Taxes - updatePlanTaxPeriod");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/plan/${planId}/taxperiod`
    );

    const taxPeriodMap = mapFETaxPeriodToBE(planId);

    axios
      .post(targetUrl, taxPeriodList.map(taxPeriodMap))
      .then(() => resolve({}));
  });
};

export const resetClientProfileTaxDeductions = (advisorId, clientId) => {
  console.log("resetClientProfileTaxDeductions");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/tax-deduction/reset`
    );

    axios.delete(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const resetAdvisorSettingsTaxDeductions = (advisorId) => {
  console.log("resetAdvisorSettingsTaxDeductions");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/settings/tax-deduction/reset`
    );

    axios.delete(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const resetClientProfileTaxBrackets = (advisorId, clientId) => {
  console.log("resetClientProfileTaxBrackets");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/marginal-tax-bracket/reset`
    );

    axios.delete(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const resetAdvisorSettingsTaxBrackets = (advisorId) => {
  console.log("resetAdvisorSettingsTaxBrackets");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/settings/marginal-tax-bracket/reset`
    );

    axios.delete(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveAdminTaxDeductions = (userId, taxDeductionData) => {
  console.log("saveAdminTaxDeductions");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/admin/${userId}/settings/tax-deduction-list`
    );

    const payload = taxDeductionData.map((item) => {
      return {
        scope: "Enterprise",
        inflation: item.inflation,
        annualDeduction: item.standardDeduction,
        itemizedDeduction: item.itemizedDeduction,
        taxFillingStatusType: item.taxFilingStatusKey,
        isDefault: false,
      };
    });

    axios.put(targetUrl, payload).then(() => {
      resolve({});
    });
  });
};

const getTaxFilingStatusName = (key) => {
  switch (key) {
    case TAX_FILING_STATUS_SINGLE:
      return "Single";
    case TAX_FILING_STATUS_MARRIED_SEPARATE:
      return "Married Filing Separately";
    case TAX_FILING_STATUS_HEAD:
      return "Head of Household";
    case TAX_FILING_STATUS_MARRIED_JOINT:
      return "Married Filing Jointly";
    default:
      throw `Unrecognized Filing Status: ${key}`;
  }
};

export const getAdvisorTaxDeductions = (advisorId) => {
  console.log("getAdvisorTaxDeductions");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/settings/tax-deduction`
    );

    return axios.get(targetUrl).then((response) => {
      resolve(
        response.data.payload.map((item, index) => {
          return {
            id: index,
            editIndex: index,
            inEdit: true,
            inflation: item.inflation,
            taxFilingStatusKey: item.taxFillingStatusType,
            taxFilingStatus: getTaxFilingStatusName(item.taxFillingStatusType),
            standardDeduction: item.annualDeduction,
            itemizedDeduction: item.itemizedDeduction,
          };
        })
      );
    });
  });
};

export const getAdminTaxDeductions = (userId) => {
  console.log("getAdminTaxDeductions");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/admin/${userId}/settings/tax-deduction`
    );

    return axios.get(targetUrl).then((response) => {
      resolve(
        response.data.payload.map((item, index) => {
          return {
            id: index,
            editIndex: index,
            inEdit: true,
            inflation: item.inflation,
            taxFilingStatusKey: item.taxFillingStatusType,
            taxFilingStatus: getTaxFilingStatusName(item.taxFillingStatusType),
            standardDeduction: item.annualDeduction,
            itemizedDeduction: item.itemizedDeduction,
          };
        })
      );
    });
  });
};

export const getAdminStateTaxes = (userId) => {
  console.log("getAdminStateTaxes");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/admin/${userId}/settings/state-brackets`
    );

    return axios.get(targetUrl).then((response) => {
      resolve(
        response.data.payload.map((item) => {
          return {
            ...item,
            inflationRate: item.inflationRate / 100.0,
            marginalTaxBracketValues: item.marginalTaxBracketValues.map(
              (bracket) => {
                return {
                  ...bracket,
                  taxRate: bracket.taxRate / 100,
                  inEdit: true,
                };
              }
            ),
          };
        })
      );
    });
  });
};

export const saveAdminStateTaxes = (userId, data) => {
  console.log("saveAdminStateTaxes");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/admin/${userId}/settings/state-brackets`
    );

    const payload = data.map((item) => {
      return {
        ...item,
        inflationRate: item * 100.0,
        marginalTaxBracketValues: item.marginalTaxBracketValues.map(
          (bracket) => {
            return {
              ...bracket,
              taxRate: bracket.taxRate * 100,
            };
          }
        ),
      };
    });

    return axios.put(targetUrl, payload).then(() => {
      resolve({});
    });
  });
};

export const getAdminTaxInflation = (userId) => {
  console.log("getAdminTaxInflation");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/admin/${userId}/settings/tax-inflation`;

    return axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveAdminTaxInflation = (userId, data) => {
  console.log("saveAdminTaxInflation");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/admin/${userId}/settings/tax-inflation`;

    return axios.put(targetUrl, data).then(() => {
      resolve({});
    });
  });
};

export const getCapitalGainsTaxes = (userId) => {
  console.log("getCapitalGainsTaxes");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/admin/${userId}/settings/capgains-brackets`;

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveCapitalGainsTaxes = (userId, payload) => {
  console.log("saveCapitalGainsTaxes");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/admin/${userId}/settings/capgains-brackets`;

    axios.put(targetUrl, payload).then(() => {
      resolve({});
    });
  });
};
